import { IManualSuscriptionContractSummary } from '../../../../common/interfaces'
import { formatPersonName } from './formatPersonName'
import { isMancomunado } from './getContractLabel'

export const getContractDisplayName = (contract: IManualSuscriptionContractSummary): string => {
  if (isMancomunado(contract) && contract.otrosParticipantes?.length) {
    const otherNames = contract.otrosParticipantes.map(formatPersonName).join(', ')
    return `Con ${otherNames}`
  }

  return formatPersonName(contract.titular)
}
